import {Component} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {AbstractReportPage} from "../../../framework/entity/report/report-page/abstract-report-page";
import {AccReceivableReportModel} from "./acc-receivable-report.model";
import {Plugin} from "../../../config";

@Component({
    selector: "wbo-acc-receivable-report",
    templateUrl: "./acc-receivable-report.component.html",
    providers: [provideReportModel(AccReceivableReportModel)]
})
export class AccReceivableReportComponent extends AbstractReportPage {
    Plugin = Plugin;

    constructor(public model: AccReceivableReportModel) {
        super();
    }
}
